module.exports = __webpack_public_path__ + "static/media/back_purple.91397122.png";